export default "__VITE_ASSET__DFFHmU1c__"